import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";

moment.locale("es");

const ticketCobroPdf = (values) => {
  const empresa = values.respuestaComplemento.empresa;
  const dataSat = values.respuestaComplemento.dataSat;
  const logo = empresa.logo.base64Completa;

  // Genera dinámicamente las filas para la tabla de pagos
  const filasPagos = [];

  dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].DoctoRelacionado.forEach((valuePago) => {
    let folio = '';

    if (valuePago.folioVenta) {
      folio = valuePago.folioVenta;
    }

    if (moment(dataSat.Fecha) > moment('2024-12-04T10:09:20')) {
      folio = valuePago.Serie + ' - ' + valuePago.Folio;
    }

    // Primera fila - Folio
    filasPagos.push([
      {
        text: folio,
        style: "tProductsBody",
        fontSize: 6,
        colSpan: 5,
        alignment: "left"
      },
      {}, {}, {}, {}
    ]);

    // Segunda fila - Datos del pago
    filasPagos.push([
      {
        text: valuePago.MonedaDR,
        style: "tProductsBody",
        fontSize: 6,
        alignment: "center"
      },
      {
        text: valuePago.NumParcialidad,
        style: "tProductsBody",
        fontSize: 6,
        alignment: "center"
      },
      {
        text: dineroDisabledMask(valuePago.ImpSaldoAnt),
        style: "tProductsBody",
        fontSize: 6,
        alignment: "right"
      },
      {
        text: dineroDisabledMask(valuePago.ImpPagado),
        style: "tProductsBody",
        fontSize: 6,
        alignment: "right"
      },
      {
        text: dineroDisabledMask(valuePago.ImpSaldoInsoluto),
        style: "tProductsBody",
        fontSize: 6,
        alignment: "right"
      }
    ]);
  });

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } };
  }

  return {
    pageSize: { width: 206, height: "auto" }, // 80 mm de ancho, altura ajustable
    pageMargins: [10, 10, 10, 10],
    ...cancelado,
    content: [
      {
        image: logo,
        fit: [141.73, 56.692],
        alignment: "center",
      },
      {
        text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno),
        style: "header",
        margin: [0, 10, 0, 0],
        alignment: "center",
        fontSize: 12,
      },
      {
        text: empresa.rfc,
        style: "header",
        alignment: "center",
        fontSize: 6,
      },
      {
        text: empresa.calle + " " + empresa.numeroCalle + " " + (empresa.numeroInterior ? empresa.numeroInterior : " "),
        style: "header",
        alignment: "center",
        fontSize: 6,
      },
      {
        text: empresa.colonia.nombre + " " + empresa.colonia.cp + " " + empresa.municipio.nombre + " " + empresa.municipio.nombre + " " + empresa.pais.nombre,
        style: "header",
        alignment: "center",
        fontSize: 6,
      },
      {
        text: `Regimen Fiscal: (${empresa.regimenFiscal.c_RegimenFiscal}) ${empresa.regimenFiscal.descripcion}`,
        style: "header",
        alignment: "center",
        fontSize: 6,
      },
      {
        text: "Tipo De Comprobante: (P) Pago",
        style: "header",
        alignment: "center",
        fontSize: 6,
      },

      { text: `Nº Pago - ${dataSat.Serie} - ${dataSat.Folio}`, margin: [5, 3, 0, 3], style: "header", fontSize: 10, },

      {
        margin: [0, 2, 0, 0],
        table: {
          widths: ["100%"],
          body: [
            [
              { text: dataSat.Receptor.Nombre, style: "tHeaderValue", fontSize: 6, },
            ],
            [
              { text: dataSat.Receptor.Rfc, style: "tHeaderValue", fontSize: 6, },
            ],
            [
              { text: `(${dataSat.usoDeCFDI.c_UsoCFDI}) ${dataSat.usoDeCFDI.descripcion}`, style: "tHeaderValue", fontSize: 6, },
            ],
            [
              { text: `Fecha de pago: ${moment(dataSat.Fecha).format('DD/MM/YYYY')}`, style: "tHeaderValue", fontSize: 6, },
            ],
            [
              { text: dataSat.LugarExpedicion, style: "tHeaderValue", fontSize: 6, },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
      },

      {
        table: {
          widths: ["20%", "20%", "20%", "20%", "20%",],
          headerRows: 2,
          body: [
            [
              {
                text: "DOCUMENTOS PAGADOS",
                colSpan: 5,
                style: "tTitleHeader",
                alignment: "center",
                fontSize: 12,
              },
              {}, {}, {}, {}
            ],
            [
              {
                text: "MONEDA",
                style: "tProductsHeader",
                alignment: "center",
                fontSize: 7,
              },
              {
                text: "PARC.",
                style: "tProductsHeader",
                alignment: "center",
                fontSize: 7,
              },
              {
                text: "SALDO ANT.",
                style: "tProductsHeader",
                alignment: "right",
                fontSize: 7,
              },
              {
                text: "PAGADO",
                style: "tProductsHeader",
                alignment: "right",
                fontSize: 7,
              },
              {
                text: "SALDO",
                style: "tProductsHeader",
                alignment: "right",
                fontSize: 7,
              },
            ],
            ...filasPagos,
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return (i !== 0 && i !== 1 && i % 2 === 0) ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function () {
            return "#adaaaa";
          },
          paddingTop: function (i, node) {
            return 0;
          },
        },
      },

      {
        margin: [0, 2, 0, 0],
        table: {
          widths: ["100%"],
          headerRows: 1,
          body: [
            [
              {
                text: "FORMA DE PAGO",
                style: "tTitleHeader",
                alignment: "center",
                fontSize: 10,
                margin: [0, 3, 0, 0],
              }
            ]
          ],
        },
        layout: {
          defaultBorder: false,
        },
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["100%"],
          body: [
            [
              { text: `Fecha: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].FechaPago}`, style: "tHeaderValue", fontSize: 6, },
            ],
            [
              { text: `Forma: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].FormaDePagoP}`, style: "tHeaderValue", fontSize: 6, },
            ],
            [
              { text: `Moneda: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].MonedaP}`, style: "tHeaderValue", fontSize: 6, },
            ],
            [
              { text: `Núm. Operación: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].NumOperacion || 'N/A'}`, style: "tHeaderValue", fontSize: 6, },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
      },

      {
        margin: [5, 3, 0, 3],
        table: {
          widths: ["25%", "35%", "15%", "25%"],
          body: [
            [
              { text: "TOTAL PAGADO: ", style: "tTotals", colSpan: 2, fontSize: 8, },
              {},
              { text: dineroDisabledMask(dataSat.Complemento.Any[0]["Pago20:Pagos"].Totales.MontoTotalPagos), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
              {},
            ],
            [
              {},
              {},
              {},
              {},
            ],
            [
              {
                text: numeroALetra(dataSat.Complemento.Any[0]["Pago20:Pagos"].Totales.MontoTotalPagos, dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].MonedaP),
                style: "tProductsBody",
                colSpan: 4,
                fontSize: 8,
              },
              {},
              {},
              {},
            ],
          ],
        },
        layout: "noBorders",
      },

      // Datos bancarios si existen
      ...(dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaOrdenante || empresa.banco || empresa.cuentaBanco
        ? [
          {
            margin: [0, 5, 0, 0],
            table: {
              widths: ["100%"],
              headerRows: 1,
              body: [
                [
                  {
                    text: "DATOS BANCARIOS",
                    style: "tTitleHeader",
                    alignment: "center",
                    fontSize: 10,
                    margin: [0, 3, 0, 0],
                  }
                ]
              ],
            },
            layout: {
              defaultBorder: false,
            },
          },
          {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["100%"],
              body: [
                ...(dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaOrdenante
                  ? [
                    [{ text: `Cta. Ordenante: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaOrdenante}`, style: "tHeaderValue", fontSize: 6, }],
                    [{ text: `RFC Ordenante: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].RfcEmisorCtaOrd || 'N/A'}`, style: "tHeaderValue", fontSize: 6, }],
                  ]
                  : []),
                ...(dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].NomBancoOrdExt
                  ? [
                    [{ text: `Banco Ordenante: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].NomBancoOrdExt}`, style: "tHeaderValue", fontSize: 6, }],
                  ]
                  : []),
                ...(dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaBeneficiario
                  ? [
                    [{ text: `Cta. Beneficiario: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaBeneficiario}`, style: "tHeaderValue", fontSize: 6, }],
                    [{ text: `RFC Beneficiario: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].RfcEmisorCtaBen || 'N/A'}`, style: "tHeaderValue", fontSize: 6, }],
                  ]
                  : []),
                ...(empresa.banco
                  ? [
                    [{ text: `Banco: ${empresa.banco}`, style: "tHeaderValue", fontSize: 6, }],
                  ]
                  : []),
                ...(empresa.cuentaBanco
                  ? [
                    [{ text: `Cuenta: ${empresa.cuentaBanco}`, style: "tHeaderValue", fontSize: 6, }],
                  ]
                  : []),
                ...(empresa.cuentaClabe
                  ? [
                    [{ text: `Cuenta CLABE: ${empresa.cuentaClabe}`, style: "tHeaderValue", fontSize: 6, }],
                  ]
                  : []),
                ...(empresa.swiftCode
                  ? [
                    [{ text: `Swift Code: ${empresa.swiftCode}`, style: "tHeaderValue", fontSize: 6, }],
                  ]
                  : []),
                ...(empresa.abaCode
                  ? [
                    [{ text: `ABA Code: ${empresa.abaCode}`, style: "tHeaderValue", fontSize: 6, }],
                  ]
                  : []),
              ],
            },
            layout: {
              defaultBorder: false,
              paddingTop: () => 0,
              paddingBottom: () => 0,
            },
          },
        ]
        : []),

      // Observaciones si existen
      ...(values.imprimirObservaciones && values.observaciones
        ? [
          {
            margin: [0, 5, 0, 0],
            table: {
              widths: ["100%"],
              headerRows: 1,
              body: [
                [
                  {
                    text: "OBSERVACIONES",
                    style: "tTitleHeader",
                    alignment: "center",
                    fontSize: 10,
                    margin: [0, 3, 0, 0],
                  }
                ]
              ],
            },
            layout: {
              defaultBorder: false,
            },
          },
          {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["100%"],
              body: [
                [
                  { text: values.observaciones, style: "tHeaderValue", fontSize: 6, },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
              paddingTop: () => 0,
              paddingBottom: () => 0,
            },
          },
        ]
        : []),

    ],
    styles: {
      header: {
        bold: true,
        fontSize: 15,
      },
      tTitleHeader: {
        bold: true,
        fillColor: "#cccccc",
      },
      tProductsHeader: {
        bold: true,
        fillColor: "#f5f5f5",
      },
      tProductsBody: {
        // Sin estilos específicos, usa el default
      },
      tHeaderValue: {
        // Sin estilos específicos, usa el default
      },
      tTotals: {
        bold: true,
      },
    },
    defaultStyle: {
      fontSize: 12,
    },
  };
};

export default ticketCobroPdf;